
  import * as awsAmplifyRuntime$_1hbPV_EWFXxr9T_45gjD6hCo9fbZk7MpGL5RNjBZ1HlpI from '/codebuild/output/src3564164168/src/TVEUROPE-landing/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 320,
    "md": 640,
    "lg": 768,
    "xl": 1024,
    "xxl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['awsAmplify']: { provider: awsAmplifyRuntime$_1hbPV_EWFXxr9T_45gjD6hCo9fbZk7MpGL5RNjBZ1HlpI, defaults: {} }
    }
  }
